import { createContext, useContext } from "react";
import { ISupervisor } from "../employee-leave";


type LeaveContextType = {
    supervisor: ISupervisor;
    isPersonalSummary:boolean;
    isAdmin:boolean
};

export const LeaveContext = createContext<LeaveContextType | null>(null);

export const useLeaveContext = () => {
    const context = useContext(LeaveContext);
    if (!context) throw new Error("useLeaveContext must be used within LeaveProvider");
    return context;
};
